<script lang="ts">
    import { Button } from "$lib/components/ui/button";
    import {push} from 'svelte-spa-router';
    import type { AuthContext } from "$src/infrastructure/accounts/AuthContext";
    import { getContext } from "svelte";
    import { ContextTokens } from "../contexts/ContextTokens";
    import { LogIn } from 'lucide-svelte';

    export let id: number;

    let { groupStoresAccess, activeGroupStore }  : AuthContext = getContext(ContextTokens.Auth);

    function setActiveGroupStore(id: number): void {
        var groupStore = $groupStoresAccess?.groupStores.find(gs => gs.groupStoreId == id);
        if( groupStore ) {
            activeGroupStore.set(groupStore);
            push(`/gs/${groupStore.groupStoreId}/projects`)
        }
    }

</script>
   

<Button on:click={() => setActiveGroupStore(id)}>
    <LogIn class="h-4 w-4" />
</Button>